@let expandedValue = expanded();
@let membersValue = members();
@let loadingValue = loading();

<div class="account-team-panel" [class.account-team-panel--expanded]="expandedValue && !loadingValue">
  <div
    class="account-team-panel__header"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="expandedValue"
    [attr.aria-label]="'account-team.panel.header-title' | translate"
    (click)="togglePanel()"
    (keydown.enter)="togglePanel()"
    (keydown.space)="handlePanelKeydownSpace($event)"
  >
    <img
      class="account-team-panel__header-icon"
      ngSrc="assets/icons/account-team/kaseya-one-icon.svg"
      height="16"
      width="16"
      [alt]="'account-team.panel.alts.kaseya-one-icon' | translate"
    />
    <span class="account-team-panel__header-title">
      {{ 'account-team.panel.header-title' | translate }}
    </span>
    @if (loadingValue) {
      <kds-spinner class="account-team-panel__header-spinner" />
    } @else {
      <i
        class="account-team-panel__toggle-icon fa-regular fa-chevron-up"
        [class.account-team-panel__toggle-icon--expanded]="expandedValue"
      ></i>
    }
  </div>

  @if (membersValue || error()) {
    <div class="account-team-panel__expandable">
      <div class="account-team-panel__content">
        @if (hasPanelMembers()) {
          @if (membersValue.accountManager; as member) {
            <itc-account-team-panel-member roleTitleKey="account-team.roles.account-manager.title" [member]="member" />
          }
          @if (membersValue.accountManagementManager; as member) {
            <itc-account-team-panel-member roleTitleKey="account-team.roles.account-management-manager.title" [member]="member" />
          }

          <kds-icon-button
            class="account-team-panel__action-button"
            colorScheme="secondary"
            iconClass="fa-regular fa-chevron-right"
            [buttonText]="'account-team.panel.view-team' | translate"
            [alignIconToRight]="true"
            [disabled]="loadingValue || !membersValue"
            [loading]="isDialogLoading()"
            (buttonClick)="openTeamDialog()"
          />
        } @else {
          <div class="account-team-panel__member">
            <div class="account-team-panel__member-header">
              <div class="account-team-panel__chatbot-icon">
                <i class="fa-regular fa-message-bot" aria-hidden="true"></i>
              </div>
              <div class="account-team-panel__member-info">
                <div
                  class="account-team-panel__member-role"
                  [kdsTooltip]="'account-team.billing-chatbot.role' | translate"
                  [hideIfNotTruncated]="true"
                >
                  {{ 'account-team.billing-chatbot.role' | translate }}
                </div>
                <div
                  class="account-team-panel__member-name"
                  [kdsTooltip]="'account-team.billing-chatbot.name' | translate"
                  [hideIfNotTruncated]="true"
                >
                  {{ 'account-team.billing-chatbot.name' | translate }}
                </div>
              </div>
            </div>
          </div>

          <kds-icon-button
            class="account-team-panel__action-button"
            colorScheme="secondary"
            iconClass="fa-regular fa-arrow-up-right-from-square"
            [buttonText]="'account-team.billing-chatbot.go-to-helpdesk' | translate"
            [alignIconToRight]="true"
            (buttonClick)="openBillingChatbot()"
          />
        }
      </div>
    </div>
  }
</div>
